import { Conversation, ConversationControllerApi } from "../../../../services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "../../../../utils/utils";

/**
 * @author [Rajkumar Rathod]
 */
export const useConversationCreate = () =>
  useMutationWithLoading(async (conversation: Conversation) =>
    new ConversationControllerApi(getConfigObject()).createConversation(
      conversation,
      getXtenantId()
    )
  );
